import { Card } from "src/components/atoms/Card";
import { LabelField } from "src/components/molecules/LabelField";
import { ProxyEventStats } from "src/store/proxyEvent/types";
import { getPercentage } from "src/utils/getPercentage";

interface VotingStatsBreakdownProps {
  stats: ProxyEventStats;
}

export function VotingStatsBreakdown({ stats }: VotingStatsBreakdownProps) {
  const {
    voteCount,
    fullShareVoteCount,
    nonFullShareVoteCount,
    giftedVoteCount,
    meetingAttendanceLegalProxyCount,
  } = stats;

  return (
    <Card title="Vote breakdown">
      <LabelField
        sx={{
          py: 5,
          px: 4,
          borderBottom: "1px solid #e0e0e0",
          fontWeight: 600,
        }}
        isLabelBold={true}
        label="Total voted customers"
        value={`${voteCount.toLocaleString()} customers`}
      />
      <LabelField
        sx={{
          py: 5,
          pr: 4,
          pl: 4,
          ml: 9,
          borderBottom: "1px solid #e0e0e0",
        }}
        isValueBold={false}
        label="Full share votes"
        tooltip="The number votes submitted by customers who own greater than or equal to one share."
        value={`${fullShareVoteCount.toLocaleString()} (${getPercentage(
          fullShareVoteCount,
          voteCount
        )}%)`}
      />
      <LabelField
        sx={{
          py: 5,
          pr: 4,
          pl: 4,
          ml: 9,
          borderBottom: "1px solid #e0e0e0",
        }}
        isValueBold={false}
        label="Fractional votes"
        tooltip="The number of votes submitted by customers who own less than one full share."
        value={`${nonFullShareVoteCount.toLocaleString()} (${getPercentage(
          nonFullShareVoteCount,
          voteCount
        )}%)`}
      />
      <LabelField
        sx={{
          py: 5,
          pr: 4,
          pl: 4,
          ml: 9,
          borderBottom: "1px solid #e0e0e0",
        }}
        isValueBold={false}
        tooltip="The number of votes submitted by customers whose positions were gifted to their account from a broker promotion or reward."
        label="Gifted votes"
        value={`${giftedVoteCount.toLocaleString()} (${getPercentage(
          giftedVoteCount,
          voteCount
        )}%)`}
      />
      <LabelField
        sx={{
          py: 5,
          px: 4,
          fontWeight: 600,
          borderBottom: "1px solid #e0e0e0",
        }}
        isLabelBold={true}
        label="Total legal proxy requests"
        value={`${meetingAttendanceLegalProxyCount} requests`}
      />
    </Card>
  );
}
